var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack402({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 3.63,
    width: 15,
    height: 8.74
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.77,9.52,3,5.58h.45L4.79,9.52H4.31l-.38-1.2H2.57l-.35,1.2ZM2.7,7.9H3.8L3.46,6.81c-.1-.34-.18-.61-.23-.82a6.27,6.27,0,0,1-.17.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.42,8.13l.43.14a1.85,1.85,0,0,1-.49,1,1.28,1.28,0,0,1-.87.32,1.29,1.29,0,0,1-.77-.22,1.57,1.57,0,0,1-.52-.7A3,3,0,0,1,5,7.52a2.74,2.74,0,0,1,.2-1.1,1.58,1.58,0,0,1,.55-.68,1.33,1.33,0,0,1,.78-.23,1.19,1.19,0,0,1,.8.29,1.6,1.6,0,0,1,.47.85l-.42.12C7.24,6.23,7,6,6.52,6A1,1,0,0,0,6,6.12a1.07,1.07,0,0,0-.38.51,2.52,2.52,0,0,0-.14.89,2.1,2.1,0,0,0,.28,1.21.9.9,0,0,0,.76.41.84.84,0,0,0,.6-.25A1.31,1.31,0,0,0,7.42,8.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.68,8.13l.43.14a1.86,1.86,0,0,1-.5,1A1.38,1.38,0,0,1,9,9.36a1.5,1.5,0,0,1-.52-.7,2.83,2.83,0,0,1-.21-1.14,2.57,2.57,0,0,1,.21-1.1A1.51,1.51,0,0,1,9,5.74a1.32,1.32,0,0,1,.77-.23,1.19,1.19,0,0,1,.8.29,1.53,1.53,0,0,1,.47.85l-.41.12c-.15-.54-.43-.81-.87-.81a1,1,0,0,0-.56.16,1.13,1.13,0,0,0-.37.51,2.3,2.3,0,0,0-.15.89A2.1,2.1,0,0,0,9,8.73a.89.89,0,0,0,.76.41.86.86,0,0,0,.6-.25A1.38,1.38,0,0,0,10.68,8.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.64,9.52V5.58h1.22a2,2,0,0,1,.63.07.88.88,0,0,1,.45.38,1.32,1.32,0,0,1,.16.68,1.33,1.33,0,0,1-.27.87,1.15,1.15,0,0,1-.94.34h-.82v1.6Zm.43-2.07h.83a.79.79,0,0,0,.58-.18.73.73,0,0,0,.18-.54.84.84,0,0,0-.09-.4.5.5,0,0,0-.21-.22A1,1,0,0,0,12.89,6h-.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack402);
export default __webpack_public_path__ + "static/media/Symbol_pack_402.026cac6641fa38d2d770a4ae46d1bf75.svg";
export { ForwardRef as ReactComponent };